import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/layout';

const lastUpdated = '29 يوليو 2026';

const sections = [
  {
    title: 'المعلومات التي نجمعها',
    body: [
      'بيانات الحساب مثل الاسم، البريد الإلكتروني، رقم الهاتف، الدور، وحالة الحساب.',
      'بيانات تعليمية لازمة لتشغيل المنصة مثل الفصول، الطلاب، أولياء الأمور، الجداول، الحضور، الواجبات، الدرجات، والتقارير.',
      'بيانات تشغيلية وتقنية مثل سجلات تسجيل الدخول، إعدادات الحساب، تفضيلات اللغة والإشعارات، ومعلومات الجهاز والمتصفح عند الحاجة للأمان أو الدعم.',
      'بيانات دعم يرسلها المستخدم طوعًا عبر نموذج التواصل، بما في ذلك وصف المشكلة ومعلومات الاتصال.',
    ],
  },
  {
    title: 'كيف نستخدم البيانات',
    body: [
      'تشغيل حسابات المعلمين والطلاب وأولياء الأمور والموظفين والمديرين حسب الصلاحيات المحددة.',
      'تقديم ميزات إدارة الطلاب، الحصص، المدفوعات، الإشعارات، التقارير، والتكاملات التعليمية.',
      'حماية المنصة، منع إساءة الاستخدام، التحقق من الصلاحيات، والتحقيق في الأخطاء أو البلاغات الأمنية.',
      'الرد على طلبات الدعم، إرسال إشعارات الخدمة المهمة، وتحسين جودة التجربة.',
    ],
  },
  {
    title: 'المشاركة مع مزودي الخدمة',
    body: [
      'لا نبيع بيانات المستخدمين الشخصية.',
      'قد نعالج البيانات عبر Firebase وخدمات استضافة أو مصادقة أو تخزين أو وظائف سحابية لازمة لتشغيل Class-Tech.',
      'قد تستخدم المنصة مزودي دفع أو اجتماعات أو إشعارات فقط لتنفيذ وظيفة طلبها المستخدم أو فعلها داخل الخدمة.',
      'قد نفصح عن بيانات محدودة عندما يكون ذلك مطلوبًا قانونيًا أو لحماية المستخدمين والمنصة.',
    ],
  },
  {
    title: 'بيانات الطلاب والأطفال',
    body: [
      'تتعامل Class-Tech مع بيانات تعليمية قد تخص طلابًا قاصرين، لذلك تظهر هذه البيانات فقط للمستخدمين المصرح لهم مثل المعلم أو ولي الأمر أو الإدارة المخولة.',
      'يجب أن يتم إنشاء أو ربط حسابات الطلاب وأولياء الأمور وفق موافقات ومسؤوليات الجهة التعليمية أو ولي الأمر.',
      'نحد من جمع بيانات الطلاب إلى ما يلزم لتقديم الخدمة التعليمية والإدارية.',
    ],
  },
  {
    title: 'الأمان والاحتفاظ',
    body: [
      'نستخدم صلاحيات مبنية على الأدوار وقواعد وصول في Firebase لحماية البيانات من الوصول غير المصرح.',
      'تُحفظ كلمات المرور وتدار من خلال Firebase Authentication ولا تعرضها Class-Tech داخل الواجهة.',
      'نحتفظ بالبيانات طالما كانت لازمة لتقديم الخدمة أو للامتثال أو للأمان، ثم نحذفها أو نجهلها عندما لا تبقى هناك حاجة مشروعة.',
    ],
  },
  {
    title: 'حقوق المستخدم',
    body: [
      'يمكن للمستخدم طلب الوصول إلى بياناته أو تصحيحها أو حذفها عندما تسمح متطلبات التشغيل والقانون بذلك.',
      'يمكن إدارة بعض إعدادات الخصوصية والإشعارات من داخل إعدادات الحساب.',
      'لطلبات البيانات أو الخصوصية، استخدم نموذج التواصل أو البريد المخصص أدناه.',
    ],
  },
];

const PrivacyPolicy: React.FC = () => {
  return (
    <PublicLayout>
      <div className='bg-secondary-50 text-secondary-900 dark:bg-secondary-950 dark:text-white'>
        <section className='bg-white py-16 dark:bg-secondary-900'>
          <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
            <h1 className='text-3xl font-bold text-secondary-950 dark:text-white md:text-5xl'>
              سياسة الخصوصية
            </h1>
            <p className='mt-5 max-w-3xl text-lg leading-8 text-secondary-700 dark:text-secondary-200'>
              توضح هذه السياسة كيف تجمع Class-Tech البيانات وتستخدمها وتحميها
              عند استخدام المنصة التعليمية وخدمات الدعم والتكاملات المرتبطة
              بها.
            </p>
            <p className='mt-4 text-sm text-secondary-500 dark:text-secondary-400'>
              آخر تحديث: {lastUpdated}
            </p>
          </div>
        </section>

        <section className='py-12'>
          <div className='mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-4 lg:px-8'>
            <aside className='lg:col-span-1'>
              <div className='rounded-lg border border-secondary-200 bg-white p-5 shadow-sm dark:border-secondary-800 dark:bg-secondary-900'>
                <h2 className='font-bold text-secondary-950 dark:text-white'>
                  محتويات السياسة
                </h2>
                <nav className='mt-4 space-y-2'>
                  {sections.map(section => (
                    <a
                      key={section.title}
                      href={`#${section.title}`}
                      className='block rounded-lg px-3 py-2 text-sm text-secondary-600 hover:bg-secondary-50 hover:text-primary-700 dark:text-secondary-300 dark:hover:bg-secondary-800'
                    >
                      {section.title}
                    </a>
                  ))}
                </nav>
              </div>
            </aside>

            <div className='space-y-6 lg:col-span-3'>
              {sections.map(section => (
                <section
                  key={section.title}
                  id={section.title}
                  className='scroll-mt-24 rounded-lg border border-secondary-200 bg-white p-6 shadow-sm dark:border-secondary-800 dark:bg-secondary-900'
                >
                  <h2 className='text-xl font-bold text-secondary-950 dark:text-white'>
                    {section.title}
                  </h2>
                  <ul className='mt-4 list-disc space-y-2 pr-5 leading-8 text-secondary-700 dark:text-secondary-200'>
                    {section.body.map(item => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>
        </section>

        <section className='bg-secondary-900 py-12 text-white'>
          <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
            <div className='flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between'>
              <div>
                <h2 className='text-2xl font-bold'>طلبات الخصوصية والدعم</h2>
                <p className='mt-3 max-w-2xl text-secondary-300'>
                  للاستفسارات المتعلقة بالخصوصية أو طلبات الوصول أو الحذف،
                  تواصل معنا عبر البريد أو نموذج الدعم.
                </p>
              </div>
              <div className='flex flex-col gap-3 sm:flex-row'>
                <a
                  href='mailto:info@class-tech.net'
                  className='inline-flex min-h-11 items-center justify-center rounded-lg bg-primary-600 px-5 text-sm font-semibold text-white hover:bg-primary-700'
                >
                  info@class-tech.net
                </a>
                <Link
                  to='/contact#contact-form'
                  className='inline-flex min-h-11 items-center justify-center rounded-lg border border-white px-5 text-sm font-semibold text-white hover:bg-white hover:text-secondary-900'
                >
                  إرسال طلب
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default PrivacyPolicy;
